import config from "config/appConfig";

import { create } from "zustand";
import { devtools, persist } from "zustand/middleware";

import type { BaseStateProps } from "shared/types";

const { GLOBAL_CONSTANTS } = config;

const createStore = <T>({
	initialState,
	persistant = false,
	persistantName = GLOBAL_CONSTANTS.LOCAL_STORAGE_PREFIX
}: {
	initialState: T;
	persistant?: boolean;
	persistantName?: string;
}) => {
	const createState = (set: (partial: Partial<T & BaseStateProps>) => void) => {
		const init = {
			...initialState,
			isLoading: false,
			set,
			setState: set,
			setInitial: () => set(init)
		} as Partial<T & BaseStateProps>;

		return init;
	};

	const createDataStore = persistant ? persist(createState, { name: persistantName }) : createState;
	/* @ts-expect-error: valid params */
	return create<T & BaseStateProps>(devtools(createDataStore));
};

export default createStore;
